module.exports = __webpack_public_path__ + "img/mga.05e7eae4.svg";